import { render } from "./insertEmpty.vue?vue&type=template&id=9effb056"
import script from "./insertEmpty.vue?vue&type=script&lang=js"
export * from "./insertEmpty.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__